import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';

export interface UserState {
  email: string | null;
}

export const initialState: UserState = {
  email: null,
};

export const userReducer = createReducer(
  initialState,
  on(UserActions.setEmail, (state, { email }) => ({ ...state, email })),
  on(UserActions.clearUser, () => initialState),
);
